import { render, staticRenderFns } from "./RagSourceCard.vue?vue&type=template&id=1ed23863&scoped=true"
import script from "./RagSourceCard.vue?vue&type=script&lang=js"
export * from "./RagSourceCard.vue?vue&type=script&lang=js"
import style0 from "./RagSourceCard.vue?vue&type=style&index=0&id=1ed23863&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed23863",
  null
  
)

export default component.exports